import { DomaineSpec } from './domaine-spec.model';
import { Domaine } from './domaine.model';
import { Fonction } from './fonction.model';
import { OrganismeType } from './organisme-type.model';
import { Pays } from './pays.model';
import { Service } from './service.model';
import { Structure } from './structure.model';
import { UtilisateurType } from './utilisateur-type.model';
import { RefSoustypeUtilisateur } from '../../droits/models/ref-soustype-utilisateur.model';
import { Terroir } from './terroir.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class References {
    static jsonMap = {
        services: { key: 'services', converter: new (ArrayClassConverterFactory.build(Service))(), default: () => [] },
        typesOrganismes: { key: 'typesOrganismes', converter: new (ArrayClassConverterFactory.build(OrganismeType))(), default: () => [] },
        typesUtilisateurs: { key: 'typesUtilisateurs', converter: new (ArrayClassConverterFactory.build(UtilisateurType))(), default: () => [] },
        sousTypesUtilisateurs: { key: 'sousTypesUtilisateurs', converter: new (ArrayClassConverterFactory.build(RefSoustypeUtilisateur))(), default: () => [] },
        structures: { key: 'structures', converter: new (ArrayClassConverterFactory.build(Structure))(), default: () => [] },
        domaines: { key: 'domaines', converter: new (ArrayClassConverterFactory.build(Domaine))(), default: () => [] },
        pays: { key: 'pays', converter: new (ArrayClassConverterFactory.build(Pays))(), default: () => [] },
        terroirs: { key: 'terroirs', converter: new (ArrayClassConverterFactory.build(Terroir))(), default: () => [] },
        fonctions: { key: 'fonctions', converter: new (ArrayClassConverterFactory.build(Fonction))(), default: () => [] }
    };

    public services: Service[];
    public typesOrganismes: OrganismeType[];
    public typesUtilisateurs: UtilisateurType[];
    public sousTypesUtilisateurs: RefSoustypeUtilisateur[];
    public structures: Structure[];
    public domaines: Domaine[];
    public pays: Pays[];
    public terroirs: Terroir[];
    public fonctions: Fonction[];
}
